"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const types_1 = require("../types");
const TextLinkWrapper_1 = __importDefault(require("../styled/TextLinkWrapper"));
const TextLink = ({ theme, isDisabled, onClick, href, forwardedRef, ...rest }) => {
    const handleOnClick = (event) => {
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        if (onClick !== undefined) {
            event.preventDefault();
            onClick(event);
        }
    };
    const props = {
        tabIndex: 0,
        ...(isDisabled && { 'aria-disabled': true, role: 'link' }),
        ...(!isDisabled && href && { href }),
        ...(onClick && { onClick: handleOnClick }),
        ref: forwardedRef,
        ...rest,
    };
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(TextLinkWrapper_1.default, { ...props })));
};
TextLink.propTypes = {
    children: prop_types_1.default.node.isRequired,
    color: prop_types_1.default.oneOf(Object.values(types_1.color)),
    size: prop_types_1.default.oneOf(Object.values(types_1.size)),
    underline: prop_types_1.default.oneOf(Object.values(types_1.underline)),
    isBlock: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
TextLink.defaultProps = {
    color: undefined,
    size: types_1.size.default,
    underline: types_1.underline.never,
    isBlock: false,
    isDisabled: false,
    onClick: undefined,
};
exports.default = (0, oxygen_config_1.withTheme)(TextLink, 'textLink');
